import { ApiCore } from './ApiCore';

const Api = new ApiCore();

//Auth
export const getToken = () => Api.postNoAuth(`/apiV2/usuario/generaToken`, {});
export const sendLinkRecoveryPassword = (data) => Api.postPin(`/apiV2/usuario/sendLinkRecoveryPassword`, data);
export const restablecerPass = (data) => Api.postPin(`/apiV2/usuario/restablecerPass`, data);
export const validarTokenRecuperacion = (data) => Api.postPin(`/apiV2/usuario/validarTokenRecuperacion`, data);
export const postSendPin = (data) => Api.postPin(`/apiV2/usuario/enviarPin`, data);
export const postValidatePin = (data) => Api.postPin(`/apiV2/usuario/validarPin`, data);
// Migración a JWT real (CA-15/CA-17/CA-18, ver CLAUDE.md § Sesión JWT / token
// invitado y docs/adr/0015-migracion-login-jwt.md): los tres emisores de
// sesión (password/Google/Apple) usan Api.postLogin (nunca postPin/postNoAuth,
// CA-3) y ya no pasan la contraseña por bcrypt en el cliente ni consultan
// userinfo/v2/me de Google. El endpoint viejo /apiV2/usuario/login y el
// genérico /apiV2/credencial/login quedan retirados (CA-21).
export const loginUsuario = (data) => Api.postLogin(`/apiV2/usuario/loginUsuario`, data);
export const loginGoogle = (data) => Api.postLogin(`/apiV2/credencial/loginGoogle`, data);
export const loginApple = (data) => Api.postLogin(`/apiV2/credencial/loginApple`, data);
// Renueva el access token de sesión (CA-8/CA-19/CA-36) — wrapper público de
// ApiCore._refreshSesion, con single-flight y sin degradar a token invitado.
export const refrescarSesion = () => Api.refrescarSesion();
export const UpdateCredencial = (data) => Api.postPin(`/apiV2/credencial/update`, data);
export const register = (data) => Api.postPin(`/apiV2/usuario/registroUsuario`, data);
export const getOneClickUsuario = (data) => Api.get(`/apiV2/oneClick/getOneClickUsuario?usuario_id=${data.usuario_id}&codigo_comercio=${data.codigo_comercio}`, {});
export const getOneClickCards = () => Api.get(`/apiV2/webpay/onepay/0`, {});
export const AddOneClickUsuario = (data) => Api.post2(`/apiV2/usuario/agregarOneClickUsuario`, data);
export const delOneClickUsuario = (data) => Api.delete3(`/apiV2/usuario/eliminarOneClickUsuario`, data);
export const getUserInfo = (id) => Api.get(`/apiV2/usuarioapp/${id}`)
export const updateUser = (data) => Api.put(`/apiV2/usuario/modificarDatosUsuario`, data);

export const getCategorias = () => Api.get(`/apiV2/categorias/listarCategorias`);

export const getEmpresas = () => Api.get(`/apiV2/empresa/listaEmpresasCategoria`);
export const getEmpresasByCategoria = (id) => Api.get(`/apiV2/empresa/listaEmpresasCategoria?categoria_id=${id}`);

export const getProductoByID = (id) => Api.get(`/apiV2/producto/${id}`);
export const getStockProductos = (id, generoID = null, marcaID = null) => Api.get(`/apiV2/maquina/stockProductosAPP/${id}`, { params: { generoID, marcaID } });
export const getStockProductosPaginado = (id, page = 1, registros = 20) => Api.getFull(`/apiV2/maquina/stockProductosAPP/${id}?registros=${registros}&pagina=${page}`);
export const getProductoMasVendidoEmpresa = () => Api.get(`/apiV2/empresa/getProductoMasVendidoEmpresa?limite=3`);
export const getProductoMasVendidoEmpresa2 = () => Api.get(`/apiV2/productos/getProductoMasVendido`);

export const getProductoMasVendidoByAddress = (latitud, longitud) => Api.get(`/apiV2/productos/getProductsBestSeller/latitud=${latitud}&longitud=${longitud}?limite=0`);
export const getProductoMasCercanos = (latitud, longitud) => Api.get(`/apiV2/productos/productos/getProductsNearby/latitud=${latitud}&longitud=${longitud}?limite=0`);
export const productosMasVendidosByAddress = ({ latitud, longitud }) =>
  Api.get(`/apiV2/productos/getProductsBestSeller?latitud=${latitud}&longitud=${longitud}&limite=0`);

export const getDestacados = () => Api.get(`/apiV2/producto-destacado/listaProductoDestacado`);
export const getProductoDestacadoById = (id) => Api.get(`/apiV2/producto-destacado/getProductoDestacadoById/${id}`);
export const getProductosDestacadosByMaquina = (id) => Api.get(`/apiV2/producto-destacado/getProductoDestacadoByStore/${id}`);

export const getMaquinaTienda = () => Api.get(`/apiV2/Regiones/MaquinasActivas`);
export const getMaquinaByTienda = (id) => Api.get(`/apiV2/Regiones/MaquinasActivas?empresa_id=${id}`);
export const getMaquinasByEmpresaId = (idEmpresa) => Api.get(`/apiV2/empresa/getMaquinasByEmpresaId/?id=${idEmpresa}`);

// Red de seguridad: sin idRegion/idComuna numéricos, la URL quedaba
// `?region=undefined&comuna=undefined`, que el backend respondía con HTTP
// 200 + {status:"error", message:"invalid input syntax for type integer..."}
// — origen del crash del modal "Ubicación de retiro" (ver
// CLAUDE.md/mapaUbicaciones.js). Rechazar acá protege a cualquier call site
// presente o futuro (hay 4 copias del modal, 2 muertas).
export const getMaquinaByComuna = (data) => {
  const idRegion = Number(data?.idRegion);
  const idComuna = Number(data?.idComuna);
  if (!Number.isFinite(idRegion) || !Number.isFinite(idComuna)) {
    return Promise.reject(new Error("getMaquinaByComuna: idRegion/idComuna inválidos"));
  }
  return Api.get(`/apiV2/maquina/listaMaquinas?region=${idRegion}&comuna=${idComuna}`);
};
export const getMaquinasByDistance = (data) => Api.post2(`/apiV2/store/storeByDistance`, data);
export const getGeneros = () => Api.get(`/apiV2/producto/listaGenero`);
export const getGendersByMaquina = (idMaquina) => Api.get(`/apiV2/marcas/listageneroxmaquina?maquina_id=${idMaquina}`);
export const getStockProductosPorMaquinaGeneroYMarca = (idMaquina, idGenero, idMarca) => Api.get(`/maquina/stockProductosWebApp/${idMaquina}?genero_id=${idGenero}&marca_id=${idMarca}`)

export const getBrandsByEmpresa = (idEmpresa) => Api.get(`/apiV2/producto/listaMarca/${idEmpresa}`);
export const getBrandsByMaquina = (idMaquina) => Api.get(`/apiV2/marcas/listamarcaxmaquina?maquina_id=${idMaquina}`);



export const getFormTransaction = (data) => Api.post(`/apiV2/webpay/form`, data);
export const confirmTransaction = (data) => Api.post(`/apiV2/webpay/checktransaction`, data);
export const reverseTransaction = (data) => Api.post(`/apiV2/webpay/reversetransaction`, data);
export const sendOrder = (data) => Api.post2(`/apiV2/realizarPedido`, data);
export const createOrder = (data) => { console.log('[createOrder] data:', JSON.stringify(data, null, 2)); return Api.post2(`/apiV2/createOrder`, data); };
export const getTransbankMethods = (storeId) => Api.get(`/apiV2/webpay/transbankMethods/${storeId}`);

//Mercado Pago
export const crearPreferenciaMP = (data) => Api.post2(`/apiV2/mercadopago/crearPreferencia`, data);
export const verificarPagoMP = (data, options) => Api.post2(`/apiV2/mercadopago/verificarPago`, data, options);
export const reembolsarMP = (data) => Api.post2(`/apiV2/mercadopago/reembolsar`, data);

export const createInscriptionOneClick = (data) => Api.post(`/apiV2/webpay/createInscriptionOneClick`, data);
export const confirmInscriptionOneClick = (data) => Api.post(`/apiV2/webpay/confirmInscriptionOneClick`, data);
export const deleteInscriptionOneClick = (data) => Api.post(`/apiV2/webpay/deleteInscriptionOneClick`, data);
// Api.post2 (no Api.post): authorizePayOneClick responde HTTP 200 con
// {status:"error", message} cuando Transbank rechaza la autorización (ej. el
// 422 de "comercio equivocado" que motiva el filtro en oneclickCards.js) —
// Api.post descarta ese body (`resp.data || resp.datos` -> undefined) y el
// mensaje del backend nunca llegaba a Sentry. post2 devuelve el body
// completo ({status, data|message}) sin hacer que la llamada lance en
// no-2xx (prohibido por CLAUDE.md); ver CardOneClick.jsx / pay-detail/OneClick.jsx.
export const authorizePayOneClick = (data) => Api.post2(`/apiV2/webpay/authorizePayOneClick`, data);
export const reverseOneClickTransaction = (data) => Api.post(`/apiV2/webpay/reverseOneClickTransaction`, data);

export const getMachineList = () => Api.get(`/apiV2/maquina/listaMaquinas/`);

export const getBannersList = () => Api.get(`/apiV2/banners/listarBanners`);
export const getBannersByEmpresaId = (idEmpresa) => Api.get(`/apiV2/store/getBannersByEmpresa/${idEmpresa}`);
export const getMaquinaByID = (id) => Api.get(`/apiV2/maquina/${id}`);

export const getMachineByCompanyList = (idEmpresa) => Api.get(`/apiV2/maquina/listaMaquinas/?empresa_id=${idEmpresa}`);

export const getOffers = () => Api.get(`/apiV2/oferta/getOfertasPorMaquina`);

export const getOffers2 = (idEmpresa) => Api.get(`/apiV2/oferta/getProductosConOfertas/?empresa_id=${idEmpresa}`);

export const getAllProducts = () => Api.get(`/apiV2/producto/listaProductosDisponibles?type=webstore`);
export const getAllProductsByEmpresa = (empresa_id) => Api.get(`/apiV2/producto/listaProductosDisponiblesByEmpresa?type=webstore&empresa=${empresa_id}`);

export const getStockBolsa = (data) => Api.post(`/apiV2/validarStockBolsaWeb`, data);
export const getStockBolsa2 = (data) => Api.post2(`/apiV2/validarStockBolsaV2`, data);

export const getComunasYMaquinasPorProductoNombre = (productoNombre) => Api.get(`/apiV2/producto/lista-producto-buscado/${productoNombre}`);
export const productoBuscado = ({ search, latitud, longitud }) => Api.get(`/apiV2/producto/searchProductos?latitud=${latitud}&longitud=${longitud}&search=${search}`);
export const productoBuscadoByEmpresa = ({ search, latitud, longitud, empresa_id }) => Api.get(`/apiV2/producto/searchProductosByEmpresa?latitud=${latitud}&longitud=${longitud}&search=${search}&empresa_id=${empresa_id}`);

export const sendEmail = (data) => Api.postPin(`/apiV2/svcorreo/solicitudContacto`, data);
// postFull (no post): este endpoint necesita poder fallar de forma observable
// (ver CLAUDE.md § reenvío de comprobante/QR) — Api.post nunca lanza en HTTP no-2xx.
export const sendOrderEmail = (data) => Api.postFull(`/apiV2/enviar-pedido-email`, data);

export const getCommercialNameList = () => Api.get(`/apiV2/empresa/listaEmpresasPortal`);

export const getDiscountCode = (code) => Api.get(`/apiV2/descuento/getDescuentobyNombre/${code}`);

export const getOrderById = (id) => Api.get(`/apiV2/pedido/${id}`);
export const getOrdersByUser = (id) => Api.get(`/apiV2/pedidosByEmpresa/usuario/${id}?orden=desc`);

export const createTransaccion = (data) => Api.post2(`/apiV2/transacciones/registrarTransaccion`, data);
export const updateTransaccion = (data) => Api.post2(`/apiV2/transacciones/editarTransaccion`, data);

export const getAddressByUserId = (id) => Api.get(`/apiV2/direcciones/getDirecciones/${id}`);
export const saveAddressByUserId = (data) => Api.post(`/apiV2/direcciones/guardarDireccion`, data);
export const deleteAddressById = (id) => Api.delete(`/apiV2/direcciones/eliminarDireccion/${id}`);
export const deleteAddressByUserId = (id) => Api.delete(`/apiV2/direcciones/deactiveAllAddress/${id}`);
export const updateAddressByUserId = (data) => Api.put(`/apiV2/direcciones/actualizarActive`, data);


export const getOldPasswordByUserId = (id) => Api.get(`/apiV2/usuario/oldPasswordUser/${id}`)
export const updatePassword = (data) => Api.put(`/apiV2/usuario/modificarPassUsuario`, data);